/**
 * Created by kongwm.kong on 2017/7/19.
 * 修改默认错误提示信息
 */
const dictionary = {
    en: {
        messages:{ //修改默认提示信息
            alpha: () => 'Some English Message'
        },
        attributes: {
            email: 'Email Address'
        }
    },
    zh_CN: {
        messages: { //修改默认提示信息
            alpha: () => '请输入英文字母',
            name: () => '姓名格式不正确',
            email: () => '请输入正确的邮箱',

        },
        attributes: {  //修改对应的属性  在此处不打算用   因为很多提示不统一
           // email: '邮箱文件地址测试'   //相当于是一个变量   email 里的会显示 邮箱文件地址测试
        }
    }
};
export default dictionary;


// WEBPACK FOOTER //
// ./src/config/dictionary.js